<template>
    <div>
      <el-switch
      style="display: block"
      v-validate="inputValidate"
      v-model="inputVal"
      active-color="#13ce66"
      inactive-color="#ff4949"
      :active-value="activeValue"
      :inactive-value="inactiveValue"
      :active-text="activeText"
      :inactive-text="inactiveText"
      :disabled="permission == 'r'"
      >
    </el-switch>
    <ht-field-tail v-show="permission == 'b'"  :fieldName="inputName" ></ht-field-tail>
    </div>
</template>
<script>
import utils from "@/hotent-ui-util.js"
export default {
  name: "eip-switch",
  props:[ 
    "validate",
    "value",
    "name",
    "permission",
    "activeValue",
    "inactiveValue",
    "activeText",
    "inactiveText"
    ],
  data() {
    return {
      inputName:null,
      newValidate:null
    };
  },
   computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    inputValidate: function() {
      if(this.newValidate){
        return this.newValidate;
      }
      return this.validate;
    },
   },
  created() {
    this.inputName = this.name ? this.name : utils.getName();
  }
};
</script>
<style lang="stylus" scoped>
div[aria-invalid='true'] >>> .el-input__inner, div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
</style>